<template>
  <v-container fluid>
    <v-row>
      <TurnoverChat :contact-people="contactPeople" :teams="teams" :debitors="debitors" />
    </v-row>
    <v-row>
      <CostStatistic />
    </v-row>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Default'

import TurnoverChat from '@/Components/Contract/Statistic/TurnoverChat.vue'
import CostStatistic from '@/Components/Contract/Statistic/CostStatistic.vue'
export default {
   comments: {
      TurnoverChat,
      CostStatistic
   },
   layout: (h, page) => h(Layout, [page]),

   props: {
      contactPeople: {
         type: Array,
         required: true
      },
      teams: {
         type: Array,
         required: true
      },
      debitors: {
         type: Array,
         required: true
      }
   }
}
</script>

<style>

</style>
